// @flow
import { connect } from 'react-redux'
import PricelistForm from './PricelistForm'
import type { Store } from '../../redux/store'
import store from '../../redux/store'
import * as reducer from '../../redux/ducks/pricelistEdit/reducers'
import type { State } from '../../redux/ducks/pricelistEdit/reducers'
import postJson from '../../services/postJson'

const PRICELIST_CREATE_URL = '/api/v1/pricelists'

function mapStateToProps(state: Store) {
  const {
    url,
    name,
    login,
    password,
    nameErrors,
    urlErrors,
    loginErrors,
    passwordErrors,
    isOpen,
    isLoading
  } = state.pricelistEdit
  return {
    url,
    name,
    login,
    password,
    nameErrors,
    urlErrors,
    loginErrors,
    passwordErrors,
    isOpen,
    isLoading
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onClose: () => {
      dispatch(reducer.patch({ isOpen: false }))
    },
    onChange: (diff: $Shape<State>) => {
      dispatch(reducer.patch(diff))
    },
    onPersist: () => {
      const state = store.getState()
      const { name, url, login, password } = state.pricelistEdit
      const data = {
        url: url,
        name: name,
        login: login,
        password: password
      }
      dispatch(reducer.patch({ isLoading: true }))
      postJson(PRICELIST_CREATE_URL, { pricelist: data })
        .done((response) => {
          const state = store.getState()
          const oldOptions = state.pricelistEdit.options
          const newPricelist = { id: response.data.id, name: response.data.name }
          dispatch(reducer.reset())
          dispatch(reducer.patch({ options: [newPricelist, ...oldOptions] }))
        })
        .fail((e: any) => {
          if (e.status === 422) {
            dispatch(reducer.patch(processErrors(e.responseJSON.message)))
          } else {
            window.alert('Internal error')
          }
        })
        .always(() => dispatch(reducer.patch({ isLoading: false })))
    }
  }
}

function processErrors(errors) {
  return {
    nameErrors: errors.name || [],
    urlErrors: errors.url || [],
    loginErrors: errors.login || [],
    passwordErrors: errors.password || []
  }
}

const PricelistFormContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(PricelistForm)

export default PricelistFormContainer
